<template>
  <PForm
    ref="pForm"
    heading="Activity Logs"
    :primary-cta="submitButton"
    :secondary-cta="secondaryCta"
    @close="closeForm"
  >
    <PTimeline>
      <PTimelineEntry
        v-for="(
          { created_by_name, created_date, metadata }, index
        ) in props.timelines || [{}]"
        :key="index"
      >
        <template #subtitle>
          <span class="text-weight-regular text-sm text-neutral">
            {{
              created_by_name
                ? useChangeCase(created_by_name, "capitalCase").value
                : ""
            }}
          </span>
          <span class="text-weight-regular text-sm text-neutral">
            has {{ metadata.type }} the deal settings
          </span>
          <p>
            <span class="text-weight-regular text-xs text-neutral-70">
              {{
                created_date && formatDate(created_date, "DD MMM YYYY, h:mm a")
              }}
            </span>
          </p>
        </template>
      </PTimelineEntry>
    </PTimeline>
  </PForm>
</template>

<script setup>
import { date } from "quasar";
import { useChangeCase } from "@vueuse/integrations/useChangeCase";
const { formatDate } = date;

const submitButton = ref({});
const secondaryCta = ref({});

const props = defineProps({
  timelines: {
    type: Array,
    default: () => [],
  },
});

const { toggleActivityLogsDrawer } = useDealSettingStore();

const closeForm = () => {
  toggleActivityLogsDrawer({
    open: false,
    level: 1,
  });
};
</script>
